import { render, staticRenderFns } from "./PrivacyDoc.vue?vue&type=template&id=0c4f3554&"
import script from "./PrivacyDoc.vue?vue&type=script&lang=js&"
export * from "./PrivacyDoc.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyDoc.vue?vue&type=style&index=0&id=0c4f3554&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports